export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
            <path d="M50 88C70.9868 88 88 70.9868 88 50C88 29.0132 70.9868 12 50 12C29.0132 12 12 29.0132 12 50C12 70.9868 29.0132 88 50 88Z" fill="#3F68E0" />
            <path
                d="M61.1422 36.6049C58.2719 26.9353 36.4219 27.5799 43.9744 49.8777C48.9619 64.596 38.5322 67.4392 38.5322 67.4392H61.4476"
                stroke="white"
                strokeWidth="3.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M38.5391 50.2307H57.3423" stroke="white" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
